module.exports = __webpack_public_path__ + "img/logo-small.2aec2155.svg";